import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "../Reveal";
import { getServices } from "../../lib/api";

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    getServices().then(setServices).catch(() => {});
  }, []);

  return (
    <section id="services" className="relative py-24 md:py-36 bg-surface/40 border-y border-gold/10" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-[0.25em] text-gold">Consultation Services</span>
            <h2 className="font-serif text-4xl md:text-6xl font-light mt-4 leading-tight text-foreground">
              Work with me, <span className="text-gradient-gold italic">one focused session</span> at a time.
            </h2>
            <p className="mt-6 text-muted-foreground md:text-lg font-light">
              Book a private, paid consultation tailored to where you are — from a raw clinical idea to a manuscript, a prototype, or a funding pitch.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.08}>
              <div
                className="group h-full flex flex-col justify-between rounded-2xl border border-gold/15 bg-card p-8 hover:border-gold/50 transition-colors duration-500"
                data-testid={`service-card-${s.id}`}
              >
                <div>
                  <div className="flex items-baseline justify-between mb-5">
                    <span className="text-xs uppercase tracking-[0.15em] text-gold/70">{s.duration}</span>
                    <span className="font-serif text-3xl text-gradient-gold">
                      ₹{s.price.toLocaleString("en-IN")}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl text-foreground mb-3 leading-snug">{s.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed mb-6">{s.description}</p>
                  <ul className="space-y-2 mb-8">
                    {s.highlights?.map((h) => (
                      <li key={h} className="flex items-center gap-2 text-sm text-foreground/80">
                        <Check size={15} className="text-gold shrink-0" /> {h}
                      </li>
                    ))}
                  </ul>
                </div>
                <Link
                  to={`/book?service=${s.id}`}
                  data-testid={`book-${s.id}`}
                  className="inline-flex items-center justify-between px-6 py-3.5 rounded-full border border-gold/30 text-gold text-xs uppercase tracking-[0.12em] font-semibold hover:bg-gold hover:text-ink transition-colors duration-300"
                >
                  Book this session
                  <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-300" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
